import React from "react";
import { useSelector } from "react-redux";
import HandsonTable from "../../../../components/handsonTable/handsonTable";

const AllLocationsTable = () => {
  const {
    data = [],
    colHeaders = [],
    colWidths = [],
    columns = []
  } = useSelector((state) => state.multiLocationOverview.allLocationsData.tableInfo);

  let columnSorting = Array.isArray(data[0]);

  return (
    <HandsonTable
      data={data}
      colHeaders={colHeaders}
      height="65vh"
      width={1330}
      stretchH="all"
      columnSorting
      columns={columnSorting ? columns : null}
      colWidths={colWidths}
      fragmentSelection={false}
      nestedRows
      rowHeaders
      showExportFileButton
    />
  );
};
export default AllLocationsTable;
